module.exports = __webpack_public_path__ + "static/image3-e6c3d97b6e410811899ec41e764adcc0.jpg";